<template>
    <div class="card">
        <div class="card-header bg-white">
            <div class="row align-items-center">
                <div class="col px-0">
                    <h5 class="me-auto">General</h5>
                </div>
                <div class="col-auto">
                    <div class="hstack gap-2 justify-content-end">
                        <button @click="SAVE()" type="button" class="btn btn-h btn-success px-3">
                            <div class="spinner-border spinner-border-sm" role="status" v-if="count == 1">
                                <span class="sr-only">Loading...</span>
                            </div>
                            <span v-else>Guardar</span>
                        </button>
                    </div>
                </div>
            </div>
        </div>
        <div class="card-body px-0 py-2">
            <div class="row">
                <div class="col-lg-2">
                    <small class="input-title">Monto minimo facturable</small>
                    <div class="input-group input-group-sm mb-2">
                        <div class="input-group-prepend">
                            <span class="input-group-text"><i class="bi bi-currency-dollar"></i></span>
                        </div>
                        <input type="text" v-model="data.minimum_billable_amount" class="form-control form-control-sm" @keypress="DOUBLE" :class="errors.minimum_billable_amount ? 'is-invalid' : ''" placeholder="0.00">
                        <small class="invalid-feedback" v-for="(error, index) in errors.minimum_billable_amount" :key="index">{{ error }}</small>
                    </div>
                </div>
                <div class="col-lg-3">
                    <small class="input-title">Descuento general</small>
                    <div class="input-group input-group-sm">
                        <input type="text" class="form-control form-control-sm" v-model="data.overall_discount" @keypress="DOUBLE" :class="errors.overall_discount ? 'is-invalid' : ''" placeholder="0.00">
                        <div class="input-group-append">
                            <span class="input-group-text bg-white">
                                %
                            </span>
                        </div>
                        <small class="invalid-feedback" v-for="(error, index) in errors.overall_discount" :key="index">{{ error }}</small>
                    </div>
                </div>
                <div class="col-lg-3">
                    <small class="input-title">Monto de descuento para el primer paquete</small>
                    <div class="input-group input-group-sm mb-2">
                        <div class="input-group-prepend">
                            <span class="input-group-text"><i class="bi bi-currency-dollar"></i></span>
                        </div>
                        <input type="text" v-model="data.amount_first_package" class="form-control form-control-sm" @keypress="DOUBLE" :class="errors.amount_first_package ? 'is-invalid' : ''">
                        <small class="invalid-feedback" v-for="(error, index) in errors.amount_first_package" :key="index">{{ error }}</small>
                    </div>
                </div>
                <div class="col-lg-4">
                    <small class="input-title">Impuesto para facturación masiva</small>
                    <div class="input-group input-group-sm mb-2">
                        <div class="input-group-prepend">
                            <span class="input-group-text"><i class="bi bi-bank"></i></span>
                        </div>
                        <search-tax v-model="data.tax_id" :tax="data.tax" :childclass="'rounded-left-0'" style="width: calc(100% - 31.6px);"/>
                        <small class="invalid-feedback" v-for="(error, index) in errors.tax_id" :key="index">{{ error }}</small>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    data(){
        return {
            data: {},
            errors: {},
            count: 0,
        }
    },
    mounted() {
        this.INIT()
    },
    methods: {
        INIT: function () {
            let vue = this
            axios({ url: '/calculator/global', method: 'GET' })
                .then((resp) => {
                    vue.data = resp.data
                })
                .catch((err) => {
                   let message = err.response ? err.response.data.message : err.message
                        vue.$swal({ toast: true, icon: 'error', title: message, position: 'top-end', showConfirmButton: false, timer: 3000 })
                })
        },
        SAVE: function(){
            let vue = this
            vue.count++
            if(vue.count == 1){
                vue.errors = {}
                setTimeout(() => {
                    axios({url: '/calculator/global', method: 'POST', data: vue.data })
                    .then((resp) => {
                        vue.$swal({ toast: true, icon: 'success', title: resp.data.message, position: 'top-end', showConfirmButton: false, timer: 3000 })
                    })
                    .catch((err) => {
                        if(err.response.status !== 422){
                            let message = err.response ? err.response.data.message : err.message
                            vue.$swal({ toast: true, icon: 'error', title: message, position: 'top-end', showConfirmButton: false, timer: 3000 })
                        } else {
                            vue.errors = err.response.data
                        }
                    })
                    .finally((resp)=>{
                        vue.count = 0
                    })
                }, 1000)
            }
        }
    }
}
</script>